export const draftLogicTextsPath = 'common.validation';
const makeReviewerNameValidator = (validators)=>validators.nameValidation('', {
        required: true
    });
const reviewerEmailValidator = (param)=>{
    let { allRecipientsEmail, texts, validateEmail } = param;
    return {
        validate: {
            email: validateEmail,
            unique: (value)=>{
                if (typeof value === 'string') {
                    if (allRecipientsEmail.map((r)=>r.email).includes(undefined)) {
                        return false;
                    }
                    const lowerCasedRecipientsEmail = allRecipientsEmail.map((r)=>r.email.toLowerCase());
                    const lowerCasedValue = value.toLowerCase();
                    const valueHasDuplicates = lowerCasedRecipientsEmail.filter((email)=>email === lowerCasedValue).length > 1;
                    return valueHasDuplicates ? texts.emailAlreadyAdded() : true;
                } else {
                    return false;
                }
            }
        }
    };
};
export function isEmptyReviewer(reviewer) {
    return !reviewer.firstName && !reviewer.lastName && !reviewer.email && !reviewer.clientContactId;
}
export function stripEmptyReviewers(reviewers) {
    return reviewers.filter((reviewer)=>!isEmptyReviewer(reviewer));
}
export function validateReviewers(param) {
    let { allReviewers, primaryContact, texts, validators } = param;
    const reviewers = stripEmptyReviewers(allReviewers);
    const primaryAndReviewers = (primaryContact ? [
        {
            email: primaryContact.email()
        }
    ] : []).concat(reviewers.map((r)=>({
            email: r.email || ''
        })));
    const reviewerNameValidator = makeReviewerNameValidator(validators);
    const emailValidator = reviewerEmailValidator({
        allRecipientsEmail: primaryAndReviewers,
        texts,
        validateEmail: validators.getEmailValidator(undefined, true)
    });
    return reviewers.every((r)=>reviewerNameValidator.validate.name(r.firstName) === true && reviewerNameValidator.validate.name(r.lastName) === true && emailValidator.validate.email(r.email) === true && emailValidator.validate.unique(r.email) === true);
}
